import * as React from "react";
import { SVGProps } from "react";
export const ArrowLeftDownIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.021 16.667C4.785 16.667 4.58 16.58 4.406 16.406C4.23266 16.2327 4.146 16.028 4.146 15.792V9.188C4.146 8.95133 4.23266 8.74633 4.406 8.573C4.58 8.399 4.785 8.312 5.021 8.312C5.257 8.312 5.46166 8.399 5.635 8.573C5.809 8.74633 5.896 8.95133 5.896 9.188V13.688L14.812 4.771C14.9787 4.60433 15.1837 4.521 15.427 4.521C15.6703 4.521 15.8753 4.61133 16.042 4.792C16.222 4.95866 16.3087 5.16333 16.302 5.406C16.2953 5.64933 16.2017 5.86133 16.021 6.042L7.146 14.917H11.625C11.861 14.917 12.066 15.0037 12.24 15.177C12.4133 15.351 12.5 15.556 12.5 15.792C12.5 16.028 12.4133 16.2327 12.24 16.406C12.066 16.58 11.861 16.667 11.625 16.667H5.021Z"
            fill="currentColor"
        />
    </svg>
);
ArrowLeftDownIcon.displayName = "ArrowLeftDownIcon";
